import { IATA_DIVISOR } from '@/config/config';

export default {
    calculate(length, height, width) {
        return Number(((length * height * width) / IATA_DIVISOR).toFixed(2));
    },
};
